import {immerable} from "immer";
import {StoreyTypologyType} from "@/models/types/storey-typology-type.ts";
import FileDataCreationModel from "./file-data-creation-model.ts";

class StoreyCreationModel {
    [immerable] = true;
    
    id: string;

    name: string;

    altimetry: number;

    storeyType: StoreyTypologyType;

    file?: File;
    
    index = -1;
    
    isBasement: boolean;
    
    files2d: FileDataCreationModel[] = [];

    constructor(name: string, altimetry: number, type: StoreyTypologyType, file?: File, index = -1) {
        this.id = crypto.randomUUID();
        this.name = name;
        this.altimetry = altimetry;
        this.storeyType = type;
        this.file = file;
        this.index = index;
        this.isBasement = type === 'INFRA';
        if(file)
            this.files2d.push(new FileDataCreationModel(file.name));
    }
}

export default StoreyCreationModel;
